import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { AuthService } from '../providers/auth/auth';
import { RegisterPage } from '../pages/register/register';
import { RoulettePage } from '../pages/roulette/roulette';
import { PasswordPage } from '../pages/password/password';

export const firebaseConfig = {
  apiKey: "AIzaSyBYy8osD4AZBhf5X3jM468uXLvSEF-p5zo",
  authDomain: "lunchroulette-84294.firebaseapp.com",
  databaseURL: "https://lunchroulette-84294.firebaseio.com",
  projectId: "lunchroulette-84294",
  storageBucket: "lunchroulette-84294.appspot.com",
  messagingSenderId: "783624355831"
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    RegisterPage,
    RoulettePage,
    PasswordPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      mode: "md"
    }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    RegisterPage,
    RoulettePage,
    PasswordPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AngularFireAuth,
    AuthService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts